module.exports = __webpack_public_path__ + "img/confirm-email-illustration.2aee043d.svg";